import { useAppContext } from 'src/components/app-context';
import React from 'react';
import styled from 'styled-components';

import { CardContent } from '@prisjakt/ui/card';
import { BodySmallText, FontEmphasis } from '@prisjakt/ui/text/variants';
import { RankInCategory } from '../rank-in-category';

import { BaseProps } from '../../types';
import { NewClickOutButton } from '../new-click-out-button';
import { useIsKWLP } from 'src/areas/keyword-landing-page/contexts';

type Props = Pick<
  BaseProps,
  | 'rank'
  | 'previousPriceText'
  | 'category'
  | 'onRankInCategoryClick'
  | 'onClick'
> &
  Partial<Pick<BaseProps, 'link'>>;

export const GridCardProductFooter: React.FC<Props> = props => {
  const {
    rank,
    previousPriceText,
    category,
    onRankInCategoryClick,
    onClick,
    link,
  } = props;

  const isKWLP = useIsKWLP();
  const { t } = useAppContext();

  const footerContent = [];
  if (isKWLP) {
    footerContent.push(
      <NewClickOutButton
        key="click-out-button"
        href={link || ''}
        onClick={() => onClick?.()}
        text={t('product', 'kwlp.compare-prices')}
      />
    );
  }

  if (rank && category) {
    footerContent.push(
      <RankInCategory
        key="rank-in-category"
        category={category}
        rank={rank}
        onRankInCategoryClick={onRankInCategoryClick}
      />
    );
  }

  if (previousPriceText) {
    footerContent.push(
      <PreviousPriceText
        key="previous-price-text"
        emphasis={FontEmphasis.MEDIUM}
      >
        {previousPriceText}
      </PreviousPriceText>
    );
  }

  return footerContent.length ? <Footer>{footerContent}</Footer> : null;
};

const Footer = styled(CardContent)`
  && {
    padding-top: 0;
    justify-content: end;
  }
`;

const PreviousPriceText = styled(BodySmallText)`
  && {
    flex: 0 1 auto;
  }
`;
